import React, {MutableRefObject, ReactNode} from 'react';
import {MarkerFeatures} from "@ui/leafletCustom/types/marker";
import {DivIcon, PointExpression} from "leaflet";
import {LatLngCor} from "@ui/leafletCustom/types/latLng";
import {BaseLeafletMarker} from "@ui/leafletCustom/leafletMarker/baseLeafletMarker/BaseLeafletMarker";
import {LeafletEvents} from "@ui/leafletCustom/types/handlers";

interface IProps<T extends Record<string, any>> {
    markerFeaturesRef?: MutableRefObject<MarkerFeatures>
    children?: ReactNode,
    position: LatLngCor,
    icon: DivIcon;
    eventHandlers?: LeafletEvents,
    draggable?: boolean,
    keyboard?: boolean | undefined;
    title?: string | undefined;
    alt?: string | undefined;
    zIndexOffset?: number | undefined;
    opacity?: number | undefined;
    riseOnHover?: boolean | undefined;
    riseOffset?: number | undefined;
    shadowPane?: string | undefined;
    autoPan?: boolean | undefined;
    autoPanPadding?: PointExpression | undefined;
    autoPanSpeed?: number | undefined;
    autoPanOnFocus?: boolean | undefined;
    customProperty?: T,
}

function LeafletMarker<T extends Record<string, any>>({
                                                          children,
                                                          position,
                                                          icon,
                                                          draggable,
                                                          title,
                                                          alt,
                                                          zIndexOffset,
                                                          opacity,
                                                          riseOffset,
                                                          shadowPane,
                                                          autoPan,
                                                          autoPanOnFocus,
                                                          autoPanPadding,
                                                          autoPanSpeed,
                                                          keyboard,
                                                          riseOnHover,
                                                          markerFeaturesRef,
                                                          eventHandlers,
                                                          customProperty,
                                                      }: IProps<T>) {

    return (
        <BaseLeafletMarker
            position={position}
            //@ts-ignore
            icon={icon}
            draggable={draggable}
            title={title}
            alt={alt}
            zIndexOffset={zIndexOffset}
            opacity={opacity}
            riseOffset={riseOffset}
            shadowPane={shadowPane}
            autoPan={autoPan}
            autoPanOnFocus={autoPanOnFocus}
            autoPanPadding={autoPanPadding}
            autoPanSpeed={autoPanSpeed}
            keyboard={keyboard}
            riseOnHover={riseOnHover}
            ref={markerFeaturesRef}
            eventHandlers={eventHandlers}
            customProperty={customProperty}
        >
            {children}
        </BaseLeafletMarker>
    );
};

export default LeafletMarker;